var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import * as Enumerable from "linq";
import { I18N } from "aurelia-i18n";
import { EventAggregator } from "aurelia-event-aggregator";
import { BindingEngine } from "aurelia-binding";
import { NotificationClientService } from "../../../../../../services/basics/notification-client.service";
import { BrandClientService, TemplateType, BrandingType, LotteryKeyHelper } from "../../../../../../services/modules/brand-client.service";
import { TokenClient } from "../../../../../../services/authentication/token-client.service";
import { LotteryClientService } from "../../../../../../services/modules/lottery-client.service";
import { LotteryHelper } from "../../../../client/utilities/lottery-string-helper";
import { BindingSignaler } from "aurelia-templating-resources";
import { BrandingLanguageBase } from "../../../branding/branding-langauage-base";
import { LookupClientService } from "../../../../../../services/lookups/lookup-client.service";
var WidgetLotterySelectBranding = /** @class */ (function (_super) {
    __extends(WidgetLotterySelectBranding, _super);
    function WidgetLotterySelectBranding(notificationService, i18N, brandClientService, bindingEngine, lookupClientService, eventAggregator, lotteryClientService, tokenClient, bindingSignaler) {
        var _this = _super.call(this, notificationService, i18N, brandClientService, bindingEngine, eventAggregator, lookupClientService, tokenClient, bindingSignaler) || this;
        _this.lotteryClientService = lotteryClientService;
        _this.lotteries = [];
        return _this;
    }
    WidgetLotterySelectBranding.prototype.onActivated = function (item) {
        var _this = this;
        _super.prototype.onActivated.call(this, item);
        this.lotteryClientService.getLotteriesByBrand(item.isManagingDefaultConfig ? null : item.model.brandId, item.isManagingDefaultConfig).then(function (x) {
            _this.lotteries = Enumerable.from(x).select(function (a) {
                var l = a.lottery;
                l.key = LotteryKeyHelper.getKey(l.name);
                return l;
            }).toArray();
        });
    };
    WidgetLotterySelectBranding.prototype.onSelectedItemChanged = function ($event, item) {
        if ($event.detail.item && item) {
            item.key = LotteryHelper.getLotteryKey($event.detail.item.name);
            if ($event.detail.item.id) {
                item.lotteryId = $event.detail.item.id.toString();
            }
        }
    };
    WidgetLotterySelectBranding.prototype.getTemplateType = function () {
        return TemplateType.Assets;
    };
    WidgetLotterySelectBranding.prototype.getBrandingType = function () {
        return BrandingType.Featured;
    };
    WidgetLotterySelectBranding.prototype.getBrandDetails = function () {
        return {
            brandId: this.item.model.brandId,
            brandName: this.item.model.name,
            brandLanguages: Enumerable.from(this.item.model.brandLanguages).select(function (x) { return x.languageId; }).toArray()
        };
    };
    WidgetLotterySelectBranding.prototype.addResultLottery = function () {
        if (this.model) {
            var model = new ResultLotteryModel();
            model.key = null;
            model.text = {
                en: {
                    "lottery-name": "",
                    "navigation-url": "http://"
                }
            };
            model.image = {
                en: {
                    logo: ""
                }
            };
            this.model.push(model);
        }
    };
    WidgetLotterySelectBranding.prototype.removeResultLottery = function (item) {
        var index = this.model.indexOf(item);
        if (index >= 0) {
            this.model.splice(index, 1);
        }
    };
    WidgetLotterySelectBranding.prototype.shouldNotFilter = function () {
        return true;
    };
    WidgetLotterySelectBranding.prototype.onLoaded = function () {
        if (this.model && this.model.length == 0) {
            var model = new ResultLotteryModel();
            model.key = null;
            model.text = {
                en: {
                    "lottery-name": "",
                    "navigation-url": "http://"
                }
            };
            model.image = {
                en: {
                    logo: ""
                }
            };
            this.model.push(model);
        }
    };
    WidgetLotterySelectBranding = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N,
            BrandClientService, BindingEngine, LookupClientService,
            EventAggregator, LotteryClientService, TokenClient, BindingSignaler])
    ], WidgetLotterySelectBranding);
    return WidgetLotterySelectBranding;
}(BrandingLanguageBase));
export { WidgetLotterySelectBranding };
var ResultLotteryModel = /** @class */ (function () {
    function ResultLotteryModel() {
    }
    return ResultLotteryModel;
}());
export { ResultLotteryModel };
